import axios from "axios";

const followUpUrl = "/v2/api/follow-up";

class ScheduleFollowUpService {
    static searchFollowUps(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [followUpUrl].join("");
                url = url + urlP; // e.g. ?page=1&limit=20&status=open
                let result = await axios.get(url);
                let pagingData = result.data;
                resolve(pagingData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getFollowUpById(followUpId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${followUpUrl}/${followUpId}`;
                const result = await axios.get(url);
                const followUpData = result.data;
                resolve(followUpData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static createFollowUp(followUpData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = followUpUrl;
                const result = await axios.post(url, followUpData);
                const createdFollowUp = result.data;
                resolve(createdFollowUp);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateFollowUp(followUpId, updatedFollowUpData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${followUpUrl}/${followUpId}`;
                await axios.put(url, updatedFollowUpData);
                resolve(`Follow-up record with ID ${followUpId} updated successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static markFollowUpScheduled(followUpId, schedulePayload) {
        // schedulePayload should include scheduled_schedule_id, scheduled_item_id, scheduled_date, assigned_engineer_id, etc.
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${followUpUrl}/${followUpId}/schedule`;
                await axios.patch(url, schedulePayload);
                resolve(`Follow-up record with ID ${followUpId} marked as scheduled successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static reopenFollowUp(followUpId, payload = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${followUpUrl}/${followUpId}/reopen`;
                await axios.patch(url, payload);
                resolve(`Follow-up record with ID ${followUpId} reopened successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static markFollowUpDone(followUpId, payload = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${followUpUrl}/${followUpId}/done`;
                await axios.patch(url, payload);
                resolve(`Follow-up record with ID ${followUpId} marked as done successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static deleteFollowUp(followUpId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${followUpUrl}/${followUpId}`;
                await axios.delete(url);
                resolve(`Follow-up record with ID ${followUpId} deleted successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }
}

export default ScheduleFollowUpService;
